import axios from 'axios'
import config from '../../config/configuration'

const api = axios.create({
  baseURL: config.url,
  timeout: 7000, //7 segundos
  headers: {
    'content-Type': 'application/json'
  }
})

export default api